module.exports = __webpack_public_path__ + "static/media/MagneticBoardEnviroDesigner.2a785fe9.jpg";